import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { toast } from "sonner";
import { Sparkles, Instagram, Send, CheckCircle2 } from "lucide-react";

export default function VipApplyPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    social_link: "",
    followers: "",
    message: "",
  });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/vip-apply", form);
      setSent(true);
      toast.success("Recebemos sua solicitação!");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen text-white grain">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-8 text-center">
          <span className="badge-vip mx-auto">
            <Sparkles className="w-3 h-3" /> Espaço VIP
          </span>
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-4">
            Quero ser <span className="text-[#FF007F] text-glow-pink">VIP</span>
          </h1>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">
            Se você é influenciador e quer usar a plataforma sem custo com destaque
            na nossa vitrine pública, preencha o formulário abaixo.
          </p>
        </div>

        {sent ? (
          <div className="glass rounded-2xl p-10 text-center" data-testid="vip-success">
            <CheckCircle2 className="w-12 h-12 text-[#39FF14] mx-auto mb-4" />
            <h2 className="font-display font-bold text-2xl tracking-tight">
              Solicitação enviada!
            </h2>
            <p className="text-white/60 mt-3">
              Nossa equipe vai avaliar seu perfil e entrar em contato pelo email
              informado em breve.
            </p>
          </div>
        ) : (
          <form
            onSubmit={submit}
            className="glass rounded-2xl p-8 space-y-4"
            data-testid="vip-apply-form"
          >
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                  Nome
                </label>
                <input
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="input-dark mt-2"
                  placeholder="Seu nome público"
                  data-testid="vip-name"
                />
              </div>
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                  Email
                </label>
                <input
                  required
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="input-dark mt-2"
                  data-testid="vip-email"
                />
              </div>
            </div>

            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                Link do Instagram ou principal rede
              </label>
              <div className="relative mt-2">
                <Instagram className="w-4 h-4 text-white/40 absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  required
                  value={form.social_link}
                  onChange={(e) =>
                    setForm({ ...form, social_link: e.target.value })
                  }
                  className="input-dark pl-10"
                  placeholder="https://instagram.com/seuperfil"
                  data-testid="vip-social"
                />
              </div>
            </div>

            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                Seguidores (aproximado)
              </label>
              <input
                value={form.followers}
                onChange={(e) => setForm({ ...form, followers: e.target.value })}
                className="input-dark mt-2"
                placeholder="Ex: 25K, 100K, 1M"
                data-testid="vip-followers"
              />
            </div>

            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                Sobre você (opcional)
              </label>
              <textarea
                rows={4}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="input-dark mt-2 resize-none"
                placeholder="Conta pra gente sobre seu nicho, tipo de conteúdo..."
                data-testid="vip-message"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-neon w-full"
              data-testid="vip-submit"
            >
              {loading ? "Enviando..." : "Enviar solicitação"}{" "}
              <Send className="w-4 h-4" />
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
